/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyNavReportColumnMapping } from './DailyNavReportColumnMapping';
export type FirmDailyNavConfigUpdate = {
  /**
   * Fraction of 100%, bounded to [0, 1] (e.g. 0.10 for a 10% threshold). Up to 4 decimal places.
   */
  cap_iq_short_window_delta: string;
  /**
   * Fraction of 100%, bounded to [0, 1] (e.g. 0.10 for a 10% threshold). Up to 4 decimal places.
   */
  cap_iq_long_window_delta: string;
  /**
   * Fraction of 100%, bounded to [0, 1] (e.g. 0.10 for a 10% threshold). Up to 4 decimal places.
   */
  cap_iq_since_last_valuation_delta: string;
  /**
   * Fraction of 100%, bounded to [0, 1] (e.g. 0.10 for a 10% threshold). Up to 4 decimal places.
   */
  secondary_short_window_delta: string;
  /**
   * Fraction of 100%, bounded to [0, 1] (e.g. 0.10 for a 10% threshold). Up to 4 decimal places.
   */
  secondary_long_window_delta: string;
  /**
   * Fraction of 100%, bounded to [0, 1] (e.g. 0.10 for a 10% threshold). Up to 4 decimal places.
   */
  secondary_since_last_valuation_delta: string;
  /**
   * Fraction of 100%, bounded to [0, 1] (e.g. 0.10 for a 10% threshold). Up to 4 decimal places.
   */
  secondary_change_from_mark_delta: string;
  notification_recipients: Array<string>;
  /**
   * Wall-clock time the Daily NAV report is emailed, in the trading market's timezone (e.g. 16:00 on XNYS is 16:00 America/New_York), not UTC and not the viewer's local time.
   */
  report_send_time: string;
  /**
   * Trading market whose calendar defines the NAV day, as an exchange_calendars name (ISO 10383 MIC), e.g. "XNYS". Its market close is the day's cutoff, so holidays and early closes follow the real calendar.
   */
  trading_calendar: FirmDailyNavConfigUpdate.trading_calendar;
  /**
   * Currency every monetary level on the grid is converted into -- provider prices, their average, and the mark. Firm-only. Percent deltas are unaffected: they are computed between two same-currency endpoints and so are already currency-invariant.
   */
  reporting_currency?: string;
  /**
   * Trading-day count for the short delta window. Must be less than long_window_sessions.
   */
  short_window_sessions: number;
  /**
   * Trading-day count for the long delta window. Must be greater than short_window_sessions.
   */
  long_window_sessions: number;
  /**
   * File id of the firm's CSV report template. Omit to keep the current file.
   */
  report_template?: number | null;
  /**
   * Ordered CSV column mappings. Every template column must map to a Daily NAV field or a hardcoded string.
   */
  report_column_map?: Array<DailyNavReportColumnMapping>;
  ftp_host?: string | null;
  ftp_port?: number | null;
  ftp_path?: string | null;
  ftp_username?: string | null;
  /**
   * Emails that receive the report when it is sent, in addition to FTP. Distinct from notification_recipients.
   */
  delivery_recipients?: Array<string>;
};
export namespace FirmDailyNavConfigUpdate {
  /**
   * Trading market whose calendar defines the NAV day, as an exchange_calendars name (ISO 10383 MIC), e.g. "XNYS". Its market close is the day's cutoff, so holidays and early closes follow the real calendar.
   */
  export enum trading_calendar {
    XNYS = 'XNYS',
    XNAS = 'XNAS',
    XTSE = 'XTSE',
    XLON = 'XLON',
    XETR = 'XETR',
    XPAR = 'XPAR',
    XTKS = 'XTKS',
    XHKG = 'XHKG',
    XASX = 'XASX',
  }
}

